import React, { Fragment, useState, useEffect } from "react";
import { Card, CardBody, Input, Row, Label, Modal, ModalBody, ModalHeader, Button, ModalFooter, CustomInput } from "reactstrap";
import Switch from 'rc-switch';
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import { NotificationManager } from "../../../../../../components/common/react-notifications";
import { gAPI_SubServiceProvider, gAPI_Site_Settings, putAPI_UpdateSubServiceProvider } from "../../../../../../constants/APIs";
import { AxiosAPI } from "../../../../../../helpers/AxiosAPI";
import ImageGallery from '../../../propinfo/gallery/index';
import { themeColorStorageKey } from "../../../../../../constants/defaultValues";
import no_image from '../../../../../../assets/no_image.png';
export default function SubServiceProvider({ data, isVisible, toggle, loadList, subProviders }) {
    const [allsubServiceProvider, setAllSubServiceProvider] = useState([]);
    const [subServiceProvider, setSubServiceProvider] = useState([]);
    const [list, setList] = useState([]);

    useEffect(() => {
        const result = [];
        if (data.subProviders !== null) {
            data.subProviders.map(id => {
                var s = subProviders.find(elem => elem.id === id);
                result.push(s);
            });
        }
        const property = subProviders?.map((elem) => {
            elem.checked = false;
            result.forEach((lang) => {
                if (lang.id === elem.id) {
                    elem.checked = true;
                }
            });
            return elem;
        });
        setAllSubServiceProvider(property);
    }, [subServiceProvider]);

    const handleCheckChange = (e) => {
        const values = allsubServiceProvider.map((elem) => {
            console.log(elem.id, e.target.value);
            if (elem.id == e.target.value) {
                if (elem.checked) {
                    elem.checked = false;
                } else if (!elem.checked) {
                    elem.checked = true;
                }
            }
            return {
                ...elem,
            };
        });
        setAllSubServiceProvider(values);

        const propertyArr = values
            .filter((elem) => elem.checked)
            .map((elem) => elem.id);

        setList(propertyArr);
    };
    const handleSave = () => {
        console.log('datatosave', list);


        AxiosAPI({
            method: 'put',
            url: `${putAPI_UpdateSubServiceProvider}`,
            data: {
                serviceProviderId: data.id,
                subProviders: list
            },
        })
            .then(res => {
                loadList();
                toggle();
                NotificationManager.success(
                    "",
                    "Profile updated successfully",
                    3000,
                    null,
                    null,
                    "success"
                );
            });
    };
    return (
        <Fragment>
            <Modal
                isOpen={isVisible}
                toggle={toggle}
                style={{ maxWidth: '1000px' }}
            >
                <ModalHeader toggle={toggle}>
                    Update Sub Service Provider
                </ModalHeader>
                <ModalBody>
                    <Colxx md={12}>
                        {allsubServiceProvider
                            ? allsubServiceProvider.map((p, index) => {
                                return (
                                    <CustomInput
                                        key={p.id}
                                        type="checkbox"
                                        id={index}
                                        label={p.fromName}
                                        value={p.id}
                                        checked={p.checked}
                                        onChange={handleCheckChange}
                                    />
                                )

                            })
                            : null}
                    </Colxx>
                </ModalBody>
                <ModalFooter>
                    <Colxx sm={12} className="mb-3 text-right">
                        <Button color="primary" onClick={handleSave}>
                            Save
                        </Button>
                        <Button color="secondary" className="ml-2" onClick={toggle}>
                            Close
                        </Button>
                    </Colxx>
                </ModalFooter>
            </Modal>
        </Fragment>
    )
}